module.exports = __webpack_public_path__ + "static/media/sf_2100_gray.a702f11d90689043f24816060536a55e.png";